/**
 * Connection state guard utilities for SipClient to prevent race conditions during cleanup
 */

export enum ConnectionState {
  INITIAL = 'INITIAL',
  CONNECTING = 'CONNECTING',
  CONNECTED = 'CONNECTED',
  DISCONNECTING = 'DISCONNECTING',
  DISCONNECTED = 'DISCONNECTED',
  DISPOSED = 'DISPOSED',
}

export class ConnectionStateGuard {
  private _state: ConnectionState = ConnectionState.INITIAL
  private _abortController = new AbortController()

  get state(): ConnectionState {
    return this._state
  }

  get isDisposed(): boolean {
    return this._state === ConnectionState.DISPOSED
  }

  get isConnected(): boolean {
    return this._state === ConnectionState.CONNECTED
  }

  get canTransition(): boolean {
    return !this.isDisposed && !this._abortController.signal.aborted
  }

  transitionTo(newState: ConnectionState): boolean {
    if (!this.canTransition) {
      return false
    }

    // Prevent invalid state transitions
    if (this._state === ConnectionState.DISPOSED) {
      return false
    }

    this._state = newState
    return true
  }

  abort(): void {
    this._abortController.abort()
    this._state = ConnectionState.DISPOSED
  }

  checkAborted(): boolean {
    return this._abortController.signal.aborted
  }
}
